/* ============================================================
   TODROKI — MOTION
   GSAP不使用。IntersectionObserver のみ。
   ・経年変化Reveal(褪色→本来の色)
   ・商品バリアント切替(価格/在庫/hidden id)
   ・Sticky ATC の出現制御
   ・モバイルシート
   依存ライブラリなし。defer で読み込む。
   ============================================================ */
(function () {
  "use strict";

  /* ---------- 1. Reveal ---------- */
  function initReveal() {
    var targets = document.querySelectorAll(".td-reveal");
    if (!targets.length) return;

    if (!("IntersectionObserver" in window)) {
      targets.forEach(function (el) { el.classList.add("is-in"); });
      return;
    }

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        entry.target.classList.add("is-in");
        io.unobserve(entry.target);   // 一度定着した色は戻さない
      });
    }, { rootMargin: "0px 0px -12% 0px", threshold: 0.12 });

    targets.forEach(function (el) { io.observe(el); });
  }

  /* ---------- 2. Product variants ---------- */
  function initProduct() {
    var root = document.querySelector("[data-td-product]");
    if (!root) return;

    var variants  = JSON.parse(root.getAttribute("data-td-variants") || "[]");
    var idField   = root.querySelector("[data-td-variant-id]");
    var priceEl   = root.querySelector("[data-td-price]");
    var stockEl   = root.querySelector("[data-td-stock]");
    var submits   = root.querySelectorAll("[data-td-submit]");
    var moneyFmt  = root.getAttribute("data-td-money") || "¥{{amount}}";

    function money(cents) {
      var n = (cents / 100);
      var s = n.toLocaleString("ja-JP", { maximumFractionDigits: 0 });
      return moneyFmt.replace(/\{\{\s*amount[^}]*\}\}/, s);
    }

    function apply(variant) {
      if (!variant) return;
      if (idField) idField.value = variant.id;
      if (priceEl) priceEl.textContent = money(variant.price);

      if (stockEl) {
        if (!variant.available) {
          stockEl.textContent = "SOLD OUT";
        } else if (variant.inventory_management && variant.inventory_quantity > 0 && variant.inventory_quantity <= 3) {
          stockEl.textContent = "REMAINING " + variant.inventory_quantity;
        } else {
          stockEl.textContent = "IN STOCK";
        }
      }

      submits.forEach(function (btn) {
        btn.disabled = !variant.available;
        btn.textContent = variant.available ? "ADD TO CART" : "SOLD OUT";
        btn.classList.toggle("is-disabled", !variant.available);
      });

      if (window.history && window.history.replaceState) {
        var url = new URL(window.location.href);
        url.searchParams.set("variant", variant.id);
        window.history.replaceState({}, "", url.toString());
      }
    }

    root.querySelectorAll("[data-td-variant-input]").forEach(function (input) {
      input.addEventListener("change", function () {
        var id = parseInt(input.value, 10);
        apply(variants.filter(function (v) { return v.id === id; })[0]);
      });
    });

    var checked = root.querySelector("[data-td-variant-input]:checked");
    if (checked) {
      var cid = parseInt(checked.value, 10);
      apply(variants.filter(function (v) { return v.id === cid; })[0]);
    }
  }

  /* ---------- 3. Sticky ATC ---------- */
  function initStickyAtc() {
    var bar    = document.querySelector("[data-td-stickyatc]");
    var anchor = document.querySelector("[data-td-atc-anchor]");
    if (!bar || !anchor || !("IntersectionObserver" in window)) return;

    var io = new IntersectionObserver(function (entries) {
      // 本体のカートボタンが画面から外れたときだけ出す
      bar.classList.toggle("is-active", !entries[0].isIntersecting);
    }, { threshold: 0 });

    io.observe(anchor);
  }

  /* ---------- 4. Mobile sheet ---------- */
  function initSheet() {
    var sheet = document.querySelector("[data-td-sheet]");
    if (!sheet) return;
    var openers = document.querySelectorAll("[data-td-sheet-open]");
    var closers = sheet.querySelectorAll("[data-td-sheet-close]");

    function setOpen(state) {
      sheet.classList.toggle("is-open", state);
      sheet.setAttribute("aria-hidden", state ? "false" : "true");
      document.documentElement.style.overflow = state ? "hidden" : "";
    }

    openers.forEach(function (b) { b.addEventListener("click", function () { setOpen(true); }); });
    closers.forEach(function (b) { b.addEventListener("click", function () { setOpen(false); }); });
    document.addEventListener("keydown", function (e) {
      if (e.key === "Escape") setOpen(false);
    });
  }

  function boot() {
    initReveal();
    initProduct();
    initStickyAtc();
    initSheet();
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", boot);
  } else {
    boot();
  }
})();
